function bandsLpInit() {
  const bandsSelectSection = document.querySelector('section.bands-select-model');
  const form = document.querySelector('[data-bands-lp-form]');
  const noWatch = document.querySelector('[data-bands-lp-no-watch]');

  form.addEventListener('select', (event) => {
    const targetName = event.target.getAttribute('data-name');
    if (targetName === 'watch-family') {
      if (event.detail.option.value === 'null') {
        if (noWatch) {
          noWatch.classList.remove('hidden');
        } else {
          window.location.href = '/collections/bands';
        }
      } else {
        renderProductSections(event.detail.option.first_product_handle);
      }
    }
    if (targetName === 'watch-size') {
      window.location.href = `/collections/${event.detail.option.collection_handle}`;
    }
  });

  function renderProductSections(productHandle) {
    fetch(`/products/${productHandle}?view=band-select`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const contentForLayout = html.querySelector('main.content-for-layout');
        const previousSections = document.querySelector('[data-band-selection-sections]');

        if (previousSections) {
          previousSections.remove();
        }

        bandsSelectSection.insertAdjacentHTML('afterend', `
          <div data-band-selection-sections>
            ${contentForLayout.innerHTML}
          </div>
        `);

        setTimeout(() => {
          const newSections = document.querySelector('[data-band-selection-sections]');
          const focusableDetails = newSections.querySelector('details[tabindex]');
          const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');
          const elementOffsetTop = newSections.offsetTop;
          const totalHeaderOffset = Array.from(headerGroupSections).reduce((total, el) => {
            return total + el.offsetHeight;
          }, 0);
          const scrollTop = elementOffsetTop - totalHeaderOffset + 75;
    
          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });

          if (focusableDetails) {
            focusableDetails.focus({ preventScroll: true });
          }
        }, 500);
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  bandsLpInit();
});
